(function () {
    'use strict';

    angular
        .module('app.paymentTemplates')
        .controller('PaymentTemplatePayController', PaymentTemplatePayController);

    PaymentTemplatePayController.$inject = ['$stateParams','$state', '$sce', 'common', 'dataservice', '$rootScope', '$uibModal'];
    /* @ngInject */
    function PaymentTemplatePayController($stateParams, $state, $sce, common, dataservice, $rootScope, $uibModal) {
        var vm = this;
        vm.title = 'Make Payment';
        vm.item = {};
        vm.isLicenseValid = true;
        vm.isLoading = true;
        vm.search = search;
        vm.hasSearched = false;
        vm.payInvoice = 1;
        vm.invoiceLabel = invoiceLabel;
        vm.searchDto = {};
        vm.paymentItems = [];
        vm.noSearchData = noSearchData;
        vm.doPayment = doPayment;
        vm.isSearching = false;
        vm.paymentModal = null;
        vm.clearResults = clearResults;
        vm.balanceDueLabel = "Balance Due";
        vm.showCustomAmount = false;
        vm.errorMsg = "";
        vm.trustUrl = trustUrl;
        vm.customAount = "";
      

        activate();

        function trustUrl(url) {
            return $sce.trustAsResourceUrl(url);
        }

        function activate() {
            var promises = [getItem()];
            return common.$q.all(promises).then(function (data) {
                common.logger.info('Activated ' + vm.title + ' View');
                common.notifier.notify(common.config.events.stateChanged);
                vm.isLoading = false;
            }, function (error) { });
        }

        function clearResults() {
            vm.paymentItems = [];
            vm.hasSearched = false;
            vm.searchDto.InvoiceNumber = '';
            vm.searchDto.ReservationID = '';
            vm.errorMsg = '';
        }

        function doPayment() {
            if (vm.ccForm.ProviderType === "AuthorizeDotNet") {
                vm.paymentModal = $uibModal.open({
                    ariaDescribedBy: 'modal-body',
                    templateUrl: 'authNetAcceptedPay.html',
                    backdrop: 'static',
                    controller: ['$sce', '$timeout', 'options', function ($sce, $timeout, options) {
                        var pm = this;
                        pm.token = options.token;
                        pm.formAction = $sce.trustAsResourceUrl(options.formAction);
                        $timeout(function () { $("#send_hptoken").submit(); });
                    }],
                    controllerAs: 'pm',
                    size: 'lg',
                    resolve: {
                        options: function () {
                            return {
                                token: vm.ccForm.Token,
                                formAction: vm.ccForm.SubmitToUrl
                            };
                        }
                    }
                });
            }
            else if (vm.ccForm.ProviderType === "TouchNet") {
                vm.ccForm.formAction = $sce.trustAsResourceUrl(vm.ccForm.SubmitToUrl);
                $("#touchNetForm").submit();
            }
            else if (vm.ccForm.ProviderType === "Vanco") {
                var handler = Hexea.configure({
                    pcct: vm.ccForm.Token,
                    onPayment: function (payment) {
                        processVanco(payment);
                    }
                });
                var resId = vm.searchDto.ReservationID;
                if (!resId || resId <= 0) {
                    resId = vm.paymentItems[0].ReservationId;
                }
                handler.open({
                    amount: vm.paymentItems[0].BalanceDue,
                    invoiceReference: vm.payInvoice == 1 ? vm.searchDto.InvoiceNumber : resId
                })
            }
            else if (vm.ccForm.ProviderType === "Evalon") {
                
                var paymentFields = {
                    ssl_txn_auth_token: vm.ccForm.Token
                };
                var callback = {
                    onError: function (error) {
                        vm.errorMsg = "Error in processing " + error;
                        console.log("error", error);
                    },
                    onCancelled: function () {
                        vm.errorMsg = "You cancelled the process, please search again to continue";
                    },
                    onDeclined: function (response) {
                        var jsonString = JSON.stringify(response, null, '\t');
                      //  processEvalon(jsonString, false);
                        vm.errorMsg = "Your payment was declined";
                        console.log("declined", jsonString);
                    },
                    onApproval: function (response) {
                        var jsonString = JSON.stringify(response, null, '\t');
                        processEvalon(jsonString, true);
                    }
                };
                PayWithConverge.open(paymentFields, callback);
            }
            else if (vm.ccForm.ProviderType === "CyberSource") {
                vm.ccForm.formAction = $sce.trustAsResourceUrl(vm.ccForm.SubmitToUrl);
                
                $("#cybersourceForm").submit();
            }
            else if (vm.ccForm.ProviderType === "CashNet") {
                vm.ccForm.formAction = $sce.trustAsResourceUrl(vm.ccForm.submitToUrl);
                $("#cashNetForm").submit();
            }
            else if (vm.ccForm.ProviderType === "Nelnet") {
                var expirationTime1 = moment(vm.ccForm.UtcTimeStamp);
                expirationTime1 = expirationTime1.add(5, 'minutes');
                if (moment().isAfter(expirationTime1)) {
                    template = 'expired.html';
                }
                window.location.href = vm.ccForm.IFrameIncludeUrl
            }

            else if (vm.ccForm.ProviderType === "Nelnet-IFrame") {
                var template = 'nelnetHosted.html';
                var expirationTime = moment(vm.ccForm.UtcTimeStamp);
                expirationTime = expirationTime.add(5, 'minutes');
                if (moment().isAfter(expirationTime)) {
                    template = 'expired.html';
                }

                vm.paymentModal = $uibModal.open({
                    ariaDescribedBy: 'modal-body',
                    templateUrl: template,
                    backdrop: 'static',
                    windowClass: 'nelnet-modal-window',
                    controller: ['$sce', 'options', function ($sce, options) {
                        var pm = this;
                        pm.iframeUrl = $sce.trustAsResourceUrl(options.iframeUrl);
                        pm.cancel = function () {
                            vm.paymentModal.close('cancel');
                        }
                    }],
                    controllerAs: 'pm',
                    resolve: {
                        options: function () {
                            return {
                                iframeUrl: vm.ccForm.IFrameIncludeUrl
                            };
                        }
                    }
                });
            }
        }

        function processVanco(data) {
            var resId = vm.searchDto.ReservationID;
            if (!resId || resId <= 0) {
                resId = vm.paymentItems[0].ReservationId;
            }
            var payment = {
                PaymentTemplateUId: $stateParams.id,
                SearchType: vm.payInvoice == 1 ? 0 : 1,
                InvoiceNo: vm.searchDto.InvoiceNumber,
                ReservationId: resId,
                SearchText: vm.searchDto.LastName,
                TicklerId: vm.paymentItems[0].TicklerId,
                PaymentAmount: vm.paymentItems[0].BalanceDue,
                HexeaPaymentID: data.hexeaPaymentID
            }
            dataservice.saveItem('api/PaymentTemplates/ExecuteVancoPayment', payment).then(
                function (response) {
                    $state.go("paymenttemplates.receipt", { id: response.data.ReceiptId });
                }, function (error) { });
        }

        function processEvalon(data, wasSuccessful) {
            var transResponse = JSON.parse(data);
            var resId = vm.searchDto.ReservationID;
            if (!resId || resId <= 0) {
                resId = vm.paymentItems[0].ReservationId;
            }
            var payment = {
                PaymentTemplateUId: $stateParams.id,
                SearchType: vm.payInvoice == 1 ? 0 : 1,
                InvoiceNo: vm.searchDto.InvoiceNumber,
                ReservationId: resId,
                SearchText: vm.searchDto.LastName,
                TicklerId: vm.paymentItems[0].TicklerId,

                PaymentAmount: transResponse.ssl_amount,
                TransactionId: transResponse.ssl_transaction_reference_number,
                ResponseCode: transResponse.ssl_result_message === "APPROVAL" ? 1 : 0,
                Authorization: transResponse.ssl_approval_code,
                AccountNumber: transResponse.ssl_card_number,
                AccountType: transResponse.ssl_card_short_description,
                PaymentSuccessful: wasSuccessful
            };

            
            //$('#HostedPayment').attr('src', 'about:blank');

            dataservice.saveItem('api/PaymentTemplates/ProcessPaymentFromIFrame', payment).then(
                function (response) {
                    $state.go("paymenttemplates.receipt", { id: response.data.ReceiptId });
                }, function (error) { });
        }

        function setError(msg) {
            vm.errorMsg = msg;
        }

        window.CommunicationHandler = {};
        window.authorizeAcceptJsResponseHandler = function (response) {
            if (response.messages.resultCode == "Error") {
                vm.errorMsg = "Error in processing " + response.messages.message[0].code +
                    ': ' + response.messages.message[0].text;
            }
            else {
                var resId = vm.searchDto.ReservationID;
                if (!resId || resId <= 0) {
                    resId = vm.paymentItems[0].ReservationId;
                }
                var payment = {
                    PaymentTemplateUId: $stateParams.id,
                    SearchType: vm.payInvoice == 1 ? 0 : 1,
                    InvoiceNo: vm.searchDto.InvoiceNumber,
                    ReservationId: resId,
                    SearchText: vm.searchDto.LastName,
                    TicklerId: vm.paymentItems[0].TicklerId,
                    PaymentAmount: vm.paymentItems[0].BalanceDue,
                    DataDescriptor: response.opaqueData.dataDescriptor,
                    DataValue: response.opaqueData.dataValue
                };
                dataservice.saveItem('api/PaymentTemplates/ProcessPaymentAcceptJs', payment).then(
                    function (response) {
                        $state.go("paymenttemplates.receipt", { id: response.data.ReceiptId });
                    }, function (error) { });
            }
        }

        function _parseQueryString(str) {
            var vars = [];
            var arr = str.split('&');
            var pair;
            for (var i = 0; i < arr.length; i++) {
                pair = arr[i].split('=');
                vars[pair[0]] = unescape(pair[1]);
            }
            return vars;
        }
        CommunicationHandler.onReceiveCommunication = function (argument) {
            var params = _parseQueryString(argument.qstr);
            var parentFrame = argument.parent.split('/')[4];
            switch(params['action']) {
              
                case "cancel":
                    vm.paymentModal.result.then(function () { }, function () { });
                    vm.paymentModal.dismiss('cancel');
                    switch (parentFrame) {
                        case "payment":
                            $('#HostedPayment').attr('src', 'about:blank');
                            break;
                    }
                    break;
                case "transactResponse":
                    var transResponse = JSON.parse(params['response']);
                    var resId = vm.searchDto.ReservationID;
                    if (!resId || resId <= 0) {
                        resId = vm.paymentItems[0].ReservationId;
                    }
                    var payment = {
                        PaymentTemplateUId: $stateParams.id,
                        SearchType: vm.payInvoice == 1 ? 0 : 1,
                        InvoiceNo: vm.searchDto.InvoiceNumber,
                        ReservationId: resId,
                        SearchText: vm.searchDto.LastName,
                        TicklerId: vm.paymentItems[0].TicklerId,
                        PaymentAmount: transResponse.totalAmount,
                        TransactionId: transResponse.transId,
                        ResponseCode: transResponse.responseCode,
                        Authorization: transResponse.authorization,
                        AccountNumber: transResponse.accountNumber,
                        AccountType: transResponse.accountType,
                        PaymentSuccessful: transResponse.responseCode == 1
                    };

                    if (transResponse.billTo) {
                        payment.FirstName = transResponse.billTo.firstName;
                        payment.LastName = transResponse.billTo.lastName;
                    }


                    $('#HostedPayment').attr('src', 'about:blank');
                    
                    dataservice.saveItem('api/PaymentTemplates/ProcessPaymentFromIFrame', payment).then(
                        function (response) {
                            vm.paymentModal.result.then(function () { }, function () { });
                            vm.paymentModal.dismiss('cancel');
                            $state.go("paymenttemplates.receipt", { id: response.data.ReceiptId });
                        }, function (error) { });
                    break;

            }
        }
     
        function getItem() {
            var val = $stateParams.id;
            return dataservice.getItem('api/PaymentTemplates/Pay/' + val).then(function (response) {
                vm.item = response.data;
                vm.payInvoice = response.data.DefaultButton;
                vm.resIdLabel = response.data.ReservationIDLabel;
                if (vm.item.PaymentPageTitle) {
                    $rootScope.title = vm.item.PaymentPageTitle;
                }
            }, function (error) { });
        }

        function invoiceLabel() {
            if (vm.payInvoice == 1) {
                return "Invoice Number";
            }
            else {
                return vm.item.ReservationIdBoxLabel;
            }
        }

        

        function search(customValueDue) {
            vm.isSearching = true;
            vm.paymentItems = [];
            vm.searchDto.PaymentTemplateUId = $stateParams.id;
            vm.searchDto.PaymentSearchType = vm.payInvoice == 1 ? 0 : 1;
            vm.searchDto.CustomValueDue = customValueDue;
            
            return dataservice.query("api/PaymentTemplates/SearchForTransaction", vm.searchDto)
                .then(function (response) {
                    if (response) {
                        if (response.data.PaymentItems) {
                            vm.paymentItems = response.data.PaymentItems;
                            if (vm.paymentItems.length === 1) {
                                if (vm.paymentItems[0].AllowCustomAmount) {
                                    vm.balanceDueLabel = "Amount To Pay";
                                    vm.showCustomAmount = true;
                                }
                                else {
                                    vm.showCustomAmount = false;
                                }
                                     
                            }
                        }

                        var formData = response.data.FormData;
                        
                        if (formData) {
                            vm.ccForm = formData;
                            if (vm.ccForm.ProviderType === "Evalon" || vm.ccForm.ProviderType == "Vanco") {
                                var evaScript = document.createElement("script");
                                evaScript.src = vm.ccForm.SubmitToUrl;
                                var ref = document.querySelector('script');

                                // Insert the new node before the reference node
                                ref.parentNode.insertBefore(evaScript, ref);
                            }
                            else if (vm.ccForm.ProviderType === "AuthorizeAcceptJs") {
                                var acceptUIScript = document.createElement("script");
                                acceptUIScript.src = vm.ccForm.ScriptToInclude;
                                var ref = document.querySelector('script');

                                // Insert the new node before the reference node
                                ref.parentNode.insertBefore(acceptUIScript, ref);
                            }
                            
                            vm.ccForm.action = $sce.trustAsResourceUrl(vm.ccForm.SubmitToUrl);
                        }
                    }
                    vm.hasSearched = true;
                    vm.isSearching = false;
                }, function (error) { console.log(error); })
                
        }

        function noSearchData() {
            return vm.isLoading == false && vm.paymentItems.length == 0 && vm.hasSearched == true && !vm.isSearching;
        }
    }
})();
